/**
 * Logan 日志
 * https://km.sankuai.com/page/1303603394
 */
const logan = Mach.requireModule('Logan')
// 写入 Logan 日志
const log = ({ type, data = {} }: { type: string; data: any }) => {
  if (!type) return
  const logDataStr = JSON.stringify({
    type,
    data,
  })
  logan?.log(logDataStr)
}

const Logan = {
  log,
}

export default Logan
